import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { Observable } from "rxjs";

@Component({
  selector: 'app-poll-answer-dialog',
  templateUrl: './poll-answer-dialog.component.html',
  styleUrls: ['./poll-answer-dialog.component.css']
})
export class PollAnswerDialogComponent implements OnInit {

  pollLoading: boolean;
  pollInvite: any;
  errorMessage: string;

  constructor(
    @Inject(MD_DIALOG_DATA) public data: any,
    public dialogRef: MdDialogRef<PollAnswerDialogComponent>) { }

  ngOnInit() {
    this.pollInvite = this.data.pollInvite;
    console.log(this.pollInvite);
    console.log(this.pollInvite.poll.items);

  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/poll-answer-dialog/poll-answer-dialog.component.ts